<!-- Two columns from xl: products on the left, history timeline on the right. Below xl the timeline stacks under. -->
<div class="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
  <div class="flex min-w-0 flex-col gap-4">
    <!-- Search filters both sections on names + descriptions ; add button shared by both -->
    <div class="flex items-center justify-between gap-3">
      <div class="w-1/5">
        <elcia-search [control]="searchControl" class="flex-1"/>
      </div>
      <elcia-button (onClick)="showForm()" [icon]="'plus'" [label]="'action.add-product' | translate"
                    data-testid="add-customer-product"/>
    </div>

    <!-- Recurring products -->
    <elcia-card>
      <div class="flex flex-col gap-4">
        <!-- Section header -->
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2.5">
            <!-- Sync icon via PrimeNG pi class — purely decorative -->
            <span aria-hidden="true" class="pi pi-sync text-surface-400 text-sm"></span>
            <span class="text-lg font-bold">{{ 'product-customer.recurring-title' | translate }}</span>
            <span class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 tabular-nums">
              {{ recurringProducts().length }}
            </span>
          </div>
        </div>

        @if (recurringProducts().length === 0) {
          <!-- Empty state -->
          <div class="flex flex-col items-center justify-center gap-2 py-10 text-surface-400">

            <span class="text-sm">{{ 'product-customer.recurring-empty' | translate }}</span>
          </div>
        } @else {
          <!-- divide-y renders a hairline separator between items, mirroring the ASCII-art ├──┤ divider -->
          <div class="divide-y divide-primary-50">
            @for (product of recurringProducts(); track product.id) {
              <elcia-customer-product-item
                (onDelete)="deleteProduct($event)"
                (onEdit)="openEditForm($event)"
                [highlightTick]="highlightTick()"
                [isHighlighted]="highlightedProductId() === product.id"
                [product]="product"/>
            }
          </div>
        }
      </div>
    </elcia-card>

    <!-- One-shot products -->
    <elcia-card>
      <div class="flex flex-col gap-4">
        <!-- Section header -->
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2.5">
            <!-- Bolt icon to visually distinguish one-shot from recurring -->
            <span aria-hidden="true" class="pi pi-bolt text-surface-400 text-sm"></span>
            <span class="text-lg font-bold">{{ 'product-customer.one-shot-title' | translate }}</span>
            <span class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 tabular-nums">
              {{ oneShotProducts().length }}
            </span>
          </div>
        </div>

        @if (oneShotProducts().length === 0) {
          <!-- Empty state -->
          <div class="flex flex-col items-center justify-center gap-2 py-10 text-surface-400">

            <span class="text-sm">{{ 'product-customer.one-shot-empty' | translate }}</span>
          </div>
        } @else {
          <div class="divide-y divide-primary-50">
            @for (product of oneShotProducts(); track product.id) {
              <elcia-customer-product-item
                (onDelete)="deleteProduct($event)"
                (onEdit)="openEditForm($event)"
                [highlightTick]="highlightTick()"
                [isHighlighted]="highlightedProductId() === product.id"
                [product]="product"/>
            }
          </div>
        }
      </div>
    </elcia-card>
  </div>
  <!-- self-start keeps the column sticky instead of being stretched by the grid row -->
  <elcia-customer-product-history
    (onSelect)="highlightProduct($event)"
    [history]="history()"
    [isLoading]="isHistoryLoading()"
    class="soft-scrollbar xl:sticky xl:top-0 xl:max-h-[calc(100vh-14rem)] xl:self-start xl:overflow-x-hidden xl:overflow-y-auto"/>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="isSaving()"
    [mustDisplayDeleteButton]="false"
    [size]="'medium'"
    [title]="'entity.product' | translate">
    <elcia-customer-product-form
      (onSubmit)="onFormSubmit($event)"
      [initialValue]="selectedProduct()"
      [isEdit]="openMode() === 'edit'"/>
  </elcia-dialog>
}

<elcia-confirm-dialog/>
